import React from 'react';

const UserForceSessionFormModal = React.lazy(() => import('../components/FormModal'));
const userForceSessionModalRegistry = {
    core_userForceSessionId: UserForceSessionFormModal
};
export default userForceSessionModalRegistry;
